import React, { useState } from 'react';

const OptimizedImage = ({ src, alt, className = '', loading = 'lazy', ...props }) => {
  const [error, setError] = useState(false);

  if (!src) {
    return <img src="https://via.placeholder.com/600x400?text=Image+Missing" alt={alt || 'Missing'} className={className} />;
  }

  // Attempt to generate WebP URL by replacing extensions if possible
  // If the src is from the same server or follows a standard format
  const isImage = typeof src === 'string';
  const extensionRegex = /\.(jpg|jpeg|png)$/i;
  
  let webpSrc = null;
  if (isImage && extensionRegex.test(src) && !src.startsWith('data:')) {
    webpSrc = src.replace(extensionRegex, '.webp');
  }

  // Fallback if webp generation fails or is not applicable
  const handleError = (e) => {
    if (!error && webpSrc) {
      // First try failed (likely the WebP version).
      // Unmounting the source will cause the browser to evaluate the fallback img.
      setError(true);
    } else if (props.onError) {
      // The standard src also failed, pass to custom error handler
      props.onError(e);
    }
  };

  // We must destructure onError out of props if it exists, so we don't accidentally overwrite handleError
  const { onError, ...restProps } = props;

  return (
    <picture>
      {webpSrc && !error && (
        <source srcSet={webpSrc} type="image/webp" />
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        {...restProps}
        onError={handleError}
      />
    </picture>
  );
};

export default OptimizedImage;
